module.exports = __webpack_public_path__ + "static/s5-object1-61c14a34849245af245189a520ba2e31.png";